// extracted by mini-css-extract-plugin
module.exports = {"CsaButtonWrapper":"CsaButton_CsaButtonWrapper__1KVUF","button":"CsaButton_button__3VIDB"};